import { clsx } from "clsx";
import {
  type CSSProperties,
  forwardRef,
  type ForwardRefRenderFunction,
  type HTMLAttributes,
  type PropsWithChildren,
} from "react";

import { useDataAttributes } from "../../hooks/useDataAttributes.ts";
import style from "./Stack.module.css";

export interface HStackProps {
  /** @default 5px */
  spacing?: number;
  /** @default false */
  wrap?: boolean;
  className?: string;
  style?: CSSProperties;
  domProps?: HTMLAttributes<HTMLDivElement>;
}

const HStackRender: ForwardRefRenderFunction<HTMLDivElement, PropsWithChildren<HStackProps>> = (props, ref) => {
  const dataAttributes = useDataAttributes(props);

  return (
    <div
      {...props.domProps}
      data-testid="h-stack"
      {...dataAttributes}
      ref={ref}
      className={clsx(style.h_stack, props.className)}
      style={{
        gap: props.spacing != undefined ? `${props.spacing}px` : undefined,
        flexWrap: props.wrap ? "wrap" : undefined,
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};

export const HStack = forwardRef(HStackRender);
